import { EditorTheme } from "components/editorComponents/CodeEditor/EditorConfig";

export const POST_BODY_FORM_DATA_KEY = "displayFormat";
export const THEME = EditorTheme.LIGHT;
